type FreetextValues = Array<{ value: string }>;

/**
 * Builds a freetext array of exactly `length` entries and carries over the already typed values by index.
 * Passing `undefined` as `currentValues` produces an empty array, which is what we want when the user
 * switches to a different template.
 */
export const resizeFreetextValues = (currentValues: FreetextValues | undefined, length: number): FreetextValues =>
    Array.from({ length }, (_, index) => ({ value: currentValues?.[index]?.value ?? '' }));
